'use strict';

require('./shim')();